import React from "react";

import clsx from "clsx";
import { useNavigate } from "react-router-dom";

import { Switch } from "@components/shared/switch";
import { useUser } from "@components/user-context";
import { useFeatureFlags, useUpdateUserFeatureFlag } from "@hooks/http";
import { prettyLogEvent, logEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

export const NewSalesExperienceSwitch = ({
  switchClassname,
  basic,
}: {
  switchClassname?: string;
  basic?: boolean;
}) => {
  const { hasFeatureFlag } = useFeatureFlags();
  const [updateUserFeatureFlag] = useUpdateUserFeatureFlag();
  const navigate = useNavigate();
  const { user } = useUser();
  const onNewSalesPageExperience = !hasFeatureFlag("doNotShowNewSalesPage");

  const toggleNewSalesPageExperience = async (value: boolean) => {
    if (value === false) {
      logEvent("Turn off new sales page experience");
      prettyLogEvent.onClick({
        page: Pages.SALES,
        domain: "Turn off new sales page experience",
        user,
      });
    }

    await updateUserFeatureFlag("doNotShowNewSalesPage", !value);

    const url = new URL(window.location.href);
    navigate(url.pathname);
    window.location.reload();
  };

  return (
    <div className="flex items-center">
      <div className={clsx(" mr-2 mr-", { "text-xs text-[#717680]": !basic })}>
        Switch to {onNewSalesPageExperience ? "old" : "new"} Sales page
        experience
      </div>
      <Switch
        size="small"
        value={onNewSalesPageExperience}
        onChange={toggleNewSalesPageExperience}
        labelClassname={switchClassname}
        id="feature-flag-tabs-and-flyout-switch"
      />
    </div>
  );
};
